import clsx from 'clsx';
import styles from './styles.module.scss';

type TabProps = {
  title: string;
  selected: boolean;
  onClick: () => void;
};

const Tab: React.FC<TabProps> = (props) => {
  const { title, selected, onClick } = props;

  return (
    <button
      type='button'
      className={clsx(styles.container, selected && styles.selected)}
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export default Tab;
